const Products = [
	{
		id: 0,
		category: 'all',
		show: true,
	},
	{
		id: 1,
		category: 'burger',
		show: false,
	},
	{
		id: 2,
		category: 'pizza',
		show: false,
	},
	{
		id: 3,
		category: 'snacks',
		show: false,
	},
	{
		id: 4,
		category: 'softdrinks',
		show: false,
	},
	{
		id: 5,
		category: 'coffee',
		show: false,
	},
	{
		id: 7,
		category: 'ice-cream',
		show: false,
	},
];

export default Products;
